import React, { Component } from 'react';

import InsuranceDevice from 'components/InsuranceDevice';
import ActivateInsuranceDevice from 'components/ActivateInsuranceDevice';
import DeviceCancel from 'components/DeviceCancel';

import { connect } from 'react-redux';
import { findDevice, cancelDevice } from '../actions/insuranceDevices';
import { getDevice, getSubmitStatus } from 'reducers';

export class ViewDevice extends Component {
  componentDidMount() {
    this.props.findDevice(this.props.match.params.id);
  }

  render() {
    const { device, saveStatus, cancelDevice } = this.props;
    const contractId = this.props.match.params.id;

    if (!device) {
      return <div>Loading</div>;
    } else {
      return (
        <div>
          <h1>Protected Device</h1>
          <InsuranceDevice device={device} />
          {device.status !== 'active' && (
            <ActivateInsuranceDevice id={device.id} />
          )}
          <DeviceCancel
            contractId={contractId}
            onSubmit={(values) => cancelDevice(device.id, values)}
            saveStatus={saveStatus}
          />
        </div>
      );
    }
  }
}

const mapStateToProps = (
  state,
  {
    location,
    match: {
      params: { id },
    },
  },
) => ({
  device: getDevice(state, id),
  saveStatus: getSubmitStatus(state, 'deviceCancel'),
});

const mapDispatchToProps = {
  findDevice,
  cancelDevice,
};

export const ConnectedViewDevice = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ViewDevice);

export default ConnectedViewDevice;
